(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() { this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); }
    reveal() { this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-dossier"]) return;
  try {
    
  (function () {
    function fbRupees(cents) {
      var value = (cents || 0) / 100;
      try {
        return '₹' + value.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      } catch (e) {
        return '₹' + value;
      }
    }

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-dossier-thumb]');
      if (!thumb) return;
      var wrapper = thumb.closest('.fb-dossier__media');
      if (!wrapper) return;
      var mainImg = wrapper.querySelector('[data-dossier-main-image] img');
      var fullSrc = thumb.getAttribute('data-full-src');
      if (mainImg && fullSrc) { mainImg.src = fullSrc; mainImg.removeAttribute('srcset'); }
      wrapper.querySelectorAll('[data-dossier-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });

    // Quantity stepper + "Make it N". The quantity input is a plain
    // name="quantity" field inside the product form, so Shopify handles the
    // rest; these buttons only nudge its value.
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-fb-qty-step]');
      if (step) {
        var stepInput = document.querySelector('[data-fb-qty-input="' + step.getAttribute('data-fb-qty-for') + '"]');
        if (!stepInput) return;
        var next = (parseInt(stepInput.value, 10) || 1) + (parseInt(step.getAttribute('data-fb-qty-step'), 10) || 0);
        stepInput.value = next < 1 ? 1 : next;
        return;
      }

      var apply = e.target.closest('[data-fb-bundle-apply]');
      if (!apply) return;
      var qty = parseInt(apply.getAttribute('data-bundle-qty'), 10) || 2;
      var qtyInput = document.querySelector('[data-fb-qty-input="' + apply.getAttribute('data-fb-bundle-apply') + '"]');
      if (!qtyInput) return;
      qtyInput.value = qty;
      var label = apply.querySelector('[data-fb-bundle-text]');
      if (label) {
        if (!apply.getAttribute('data-fb-bundle-original')) {
          apply.setAttribute('data-fb-bundle-original', label.textContent);
        }
        label.textContent = 'Quantity set to ' + qty;
      }
      apply.classList.add('is-applied');
      clearTimeout(apply._fbBundleTimer);
      apply._fbBundleTimer = setTimeout(function () {
        apply.classList.remove('is-applied');
        var original = apply.getAttribute('data-fb-bundle-original');
        if (label && original) label.textContent = original;
      }, 2400);
    });

    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-dossier-option]');
      if (!select) return;
      var form = select.closest('[id^="ProductForm-"]');
      if (!form) return;
      var sectionId = form.getAttribute('id').replace('ProductForm-', '');
      var variants = window['__dossierVariants_' + sectionId];
      if (!variants) return;
      var selects = form.querySelectorAll('[data-dossier-option]');
      var selection = Array.prototype.slice.call(selects)
        .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
        .map(function (s) { return s.value; });
      var variant = variants.find(function (v) { return v.options.every(function (opt, i) { return opt === selection[i]; }); });
      var idInput = document.getElementById('ProductFormId-' + sectionId);
      var submitBtn = document.getElementById('ProductSubmit-' + sectionId);
      var submitText = document.getElementById('ProductSubmitText-' + sectionId);
      var ctaLabel = (submitBtn && submitBtn.getAttribute('data-cta-label')) || 'Add to cart';
      var showPrice = !!(submitBtn && submitBtn.getAttribute('data-cta-price') === '1');
      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (submitBtn) submitBtn.disabled = !variant.available;
        if (submitText) {
          submitText.textContent = variant.available
            ? (showPrice ? ctaLabel + ' — ' + fbRupees(variant.price) : ctaLabel)
            : 'Archived';
        }
        if (variant.featured_image && variant.featured_image.src) {
          var mainImg = form.closest('.fb-dossier__layout')
            ? form.closest('.fb-dossier__layout').querySelector('[data-dossier-main-image] img')
            : document.querySelector('[data-dossier-main-image] img');
          if (mainImg) { mainImg.src = variant.featured_image.src; mainImg.removeAttribute('srcset'); }
        }
      } else {
        if (submitBtn) submitBtn.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
